import { IpAddress, IpRange } from 'cidr-calc';
import isCidr from 'is-cidr';
import isEmpty from 'lodash-es/isEmpty';
import { isIP, isV4, isV6 } from 'range_check';
import { SortOptions } from 'types/common/sorting';

export const getBrowser = () => {
  const nAgt = navigator.userAgent;
  let browserName = navigator.appName;
  let fullVersion = String(parseFloat(navigator.appVersion));
  let majorVersion = parseInt(navigator.appVersion, 10);
  let nameOffset;
  let verOffset;
  let ix;

  // In Opera 15+, the true version is after "OPR/"
  if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 4);
    // eslint-disable-next-line brace-style
  }
  // In older Opera, the true version is after "Opera" or after "Version"
  else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 6);

    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // eslint-disable-next-line brace-style
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
    browserName = 'Microsoft Internet Explorer';
    fullVersion = nAgt.substring(verOffset + 5);
    // eslint-disable-next-line brace-style
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
    browserName = 'Chrome';
    fullVersion = nAgt.substring(verOffset + 7);
    // eslint-disable-next-line brace-style
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
    browserName = 'Safari';
    fullVersion = nAgt.substring(verOffset + 7);

    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // eslint-disable-next-line brace-style
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
    browserName = 'Firefox';
    fullVersion = nAgt.substring(verOffset + 8);
    // eslint-disable-next-line brace-style
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);

    if (browserName.toLowerCase() === browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }

  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(';')) !== -1) {
    fullVersion = fullVersion.substring(0, ix);
  }

  if ((ix = fullVersion.indexOf(' ')) !== -1) {
    fullVersion = fullVersion.substring(0, ix);
  }

  majorVersion = parseInt(String(fullVersion), 10);

  if (Number.isNaN(majorVersion)) {
    fullVersion = String(parseFloat(navigator.appVersion));
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  return `${browserName}, ${fullVersion}`;
};

const table = (key = '', data = {}) => {
  let tableContent = '';

  const singleTable = (title = '', obj = {}) => {
    const objCopy = { ...obj };

    const tableHeader = `<table width="100%" border="1" cellpadding="0" cellspacing="0" bgcolor="#F2F2F2">
                                <thead>
                                    <tr>
                                        <th colspan="2"><b>${title}</b></td>
                                    </tr>
                                </thead>
                                <tbody>`;

    const tableFooter = '</tbody></table>';
    tableContent += tableHeader;

    const stringifyObj = (o: $TSFixMe) => {
      if (!o) {
        return;
      }

      Object.keys(o).forEach((k) => {
        if (typeof o[k] === 'object' && !Array.isArray(o[k])) {
          stringifyObj(o[k]);
        } else if (Array.isArray(o[k])) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0, { length } = o[k]; i < length; i++) {
            if (o[k][i] instanceof File) {
              o[k][i] = {
                modified: o[k][i].lastModifiedDate.toString(),
                name: o[k][i].name,
                size: o[k][i].size,
                type: o[k][i].type,
              };
            } else if (o[k][i] instanceof Blob) {
              o[k][i] = {
                size: o[k][i].size,
                type: o[k][i].type,
              };
            } else if (o[k][i] instanceof Error) {
              o[k][i] = {
                message: o[k][i].message,
                stack: o[k][i].stack,
              };
            }

            stringifyObj({ ...o[k][i] });
          }
        }
      });
    };

    stringifyObj(objCopy);

    for (const keyCopy in objCopy) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (obj[keyCopy] && typeof obj[keyCopy] === 'object' && Object.keys(obj[keyCopy]).length > 0) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        tableContent += `<tr><td><b>${keyCopy}</b>: </td><td><pre>${JSON.stringify(obj[keyCopy], null, 4)}</pre></td></tr>`;
      } else {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        tableContent += `<tr><td><b>${keyCopy}</b>: </td><td>${obj[keyCopy]}</td></tr>`;
      }
    }

    tableContent += tableFooter;

    return tableContent;
  };

  return singleTable(key, data);
};

export const getStringTable = (data = {}) => {
  let finalTable = '';
  Object.keys(data).forEach((key) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    finalTable += table(key, data[key]);
    finalTable += '</br>';
  });

  return finalTable;
};

export const handleStorage = (action: $TSFixMe, type: $TSFixMe, key: $TSFixMe, value: $TSFixMe) => {
  if (['localStorage', 'sessionStorage'].includes(type)) {
    switch (action) {
      case 'set':
        (window[type] as $TSFixMe).setItem(key, JSON.stringify(value));
        break;
      case 'get':
        return JSON.parse((window[type] as $TSFixMe).getItem(key));
      case 'remove':
        (window[type] as $TSFixMe).removeItem(key);
        break;
      case 'clear':
        (window[type] as $TSFixMe).clear();
        break;
      default:
        break;
    }
  }

  return undefined;
};

export const parseError = (actionError: $TSFixMe) => {
  let error = null;

  try {
    error = JSON.parse(actionError);
  } catch {
    error = actionError;
  }

  return error;
};

export const getDate = (unixTime: $TSFixMe) => {
  if (!unixTime) {
    return undefined;
  }

  const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const date = new Date(unixTime * 1000);

  return `${date.getDate()} ${monthList[date.getMonth()]} ${date.getFullYear()} - ${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:${
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  }`;
};

export const getAge = (date: $TSFixMe) => {
  const now = new Date();
  const dateInput = new Date(date);

  if (!date) {
    return 0;
  }

  let age = now.getFullYear() - dateInput.getFullYear();

  if (dateInput.getMonth() > now.getMonth()) {
    age -= 1;
  } else if (dateInput.getMonth() === now.getMonth()) {
    if (dateInput.getDate() > now.getDate()) {
      age -= 1;
    }
  }

  return age;
};

// Gets new filter and adds/removes(if empty)/updates a filters state
export const setFilter = (filters: $TSFixMe, property: $TSFixMe, value: $TSFixMe) => {
  let temp = filters;
  const filter = filters[property];

  if (filter) {
    if ((Array.isArray(value) && value.length > 0) || (value && typeof value === 'string')) {
      temp[property] = value;
    } else {
      delete temp[property];
    }
  } else if (value) {
    temp = { ...temp, [property]: value };
  }

  return { ...temp };
};

// Gets filters from object and returns parsed query
export const parseFilter = (filters: $TSFixMe) => {
  if (isEmpty(filters)) {
    return '';
  }

  let query = 'filters=';

  const filterToQuery = (property: $TSFixMe, value: $TSFixMe) => {
    let filter = `${property}=`;

    if (Array.isArray(value)) {
      value.map((item, i) => {
        if (i === 0) {
          return (filter += item);
        }

        return (filter += `,${item}`);
      });
    } else {
      filter += value;
    }

    return filter;
  };

  Object.keys(filters).map((property, i) => {
    if (i === 0) {
      return (query += filterToQuery(property, filters[property]));
    }

    return (query += ` and ${filterToQuery(property, filters[property])}`);
  });

  return query;
};

// https://stackoverflow.com/questions/34607701/how-to-remove-a-property-from-nested-javascript-objects-any-level-deep
export const removeProp = (obj: $TSFixMe, propToDelete: $TSFixMe) => {
  for (const property in obj) {
    if (typeof obj[property] === 'object') {
      // let objectToCheck = obj[property];
      delete obj.property;
      const newJsonData = removeProp(obj[property], propToDelete);
      obj[property] = newJsonData;
    } else if (property === propToDelete) {
      delete obj[property];
    }
  }

  return obj;
};

// Cleans model that have isNew tag for newly added objects (if any exist)
export const cleanNewlyAdded = <M extends object>(models: M[]): M[] =>
  models.map((item) => {
    if ('isNew' in item && item.isNew) {
      return removeProp(item, 'isNew');
    }

    return item;
  });

// Adds a new object on a model and marks it as isNew
export const addNew = <M extends object>(newItem: M | undefined, models: M[]) => {
  if (!newItem) {
    return models;
  }

  const temp = cleanNewlyAdded(models);
  temp.unshift({ ...newItem, isNew: true });

  return temp;
};

// get the value to sort
const sortValue = <M extends object>(value: M, sortParams: SortOptions<M>) => {
  if (typeof sortParams.sortSearchValue === 'function') {
    return sortParams.sortSearchValue(value);
  }

  const result = value[sortParams.sortBy];

  if (typeof result === 'string') {
    return result.toLowerCase();
  }

  return result;
};

// Sorts lists of objects
export const sort = <M extends object>(model: M[], sortParams: SortOptions<M>): M[] => {
  const temp = cleanNewlyAdded(model);

  return temp.sort((a, b) => {
    const propA = sortValue(a, sortParams);
    const propB = sortValue(b, sortParams);

    if (propA < propB) {
      return sortParams.sortDirection === 'ASC' ? -1 : 1;
    }

    if (propA > propB) {
      return sortParams.sortDirection === 'ASC' ? 1 : -1;
    }

    return 0;
  });
};

/* https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript */
export const generateRandomId = (length = 12) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const isEmailValid = (
  email: $TSFixMe, // eslint-disable-next-line max-len
) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  );

/* https://stackoverflow.com/questions/14480345/how-to-get-the-nth-occurrence-in-a-string */
export const getPosition = (string: $TSFixMe, subString: $TSFixMe, index: $TSFixMe) => string.split(subString, index).join(subString).length;

export const isIpRangeInvalid = (ipStart: $TSFixMe, ipEnd: $TSFixMe) => {
  if (!ipStart) {
    return 'Start Ip is mandatory';
  }

  const ipStartCIDR = isCidr(ipStart);

  if (!isIP(ipStart) && ipStartCIDR === 0) {
    return 'Start Ip is not valid';
  }

  if (ipEnd) {
    if (ipStartCIDR > 0 && ipEnd) {
      return 'A CIDR notation can not contain an End IP Address';
    }

    if (!isIP(ipEnd)) {
      return 'End Ip is not valid';
    }

    if (Number(ipStart.replace(/\.|:/g, '')) > Number(ipEnd.replace(/\.|:/g, ''))) {
      return 'End IP Address must be higher than Start IP Address';
    }

    // check range with ipEnd
    const ipRange = new IpRange(IpAddress.of(ipStart), IpAddress.of(ipEnd));

    const prefix = ipRange
      .toCidrs()
      .toString()
      .substring(getPosition(ipRange.toCidrs().toString(), '/', 1) + 1);

    // @ts-expect-error ts-migrate(2365) FIXME: Operator '<' cannot be applied to types 'string' a... Remove this comment to see the full error message
    if (isV6(ipStart) && prefix < 48) {
      return 'IP Range is too wide';
    }

    if (isV4(ipStart)) {
      const prefixStart = ipStart.substring(0, getPosition(ipStart, '.', 2));
      const prefixEnd = ipEnd.substring(0, getPosition(ipEnd, '.', 2));

      if (prefixStart !== prefixEnd) {
        return 'IP Range is too wide';
      }
    }
  } else if (ipStartCIDR > 0) {
    // check range if CIDR
    const prefix = ipStart.substring(getPosition(ipStart, '/', 1) + 1);

    if ((ipStartCIDR === 4 && prefix < 16) || (ipStartCIDR === 6 && prefix < 48)) {
      return 'IP Range is too wide';
    }
  }

  return '';
};

export const bytesToUnit = (bytes: $TSFixMe, byteSize = 1024, unit = 0) => {
  // unit 0- bytes 1- kB 2- MB - 3 GB - 4 TB so on..
  const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB'];

  if (unit === 0) {
    return `${bytes} ${sizes[unit]}`;
  }

  return `${(bytes / byteSize ** unit).toFixed(2)} ${sizes[unit]}`;
};

export const bytesToSize = (bytes: $TSFixMe, byteSize = 1024, fixed = 1) => {
  const convert = bytes >= 0 ? parseFloat(bytes) : parseFloat(bytes) * -1;

  // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
  if (convert === 0 || convert === '0') {
    return 0;
  }

  const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB'];

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const i = parseInt(Math.floor(Math.log(convert) / Math.log(byteSize)), 10);

  if (i === 0) {
    return `${convert} ${sizes[i]}`;
  }

  return `${(convert / byteSize ** i).toFixed(fixed)} ${sizes[i]}`;
};

export const bytesToSizeInt = (bytes: $TSFixMe, byteSize = 1024, fixed = 1) => {
  const convert = bytes >= 0 ? parseFloat(bytes) : parseFloat(bytes) * -1;

  // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
  if (convert === 0 || convert === '0') {
    return 0;
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const i = parseInt(Math.floor(Math.log(convert) / Math.log(byteSize)), 10);

  if (i === 0) {
    return bytes;
  }

  return (convert / byteSize ** i).toFixed(fixed);
};

export const formatNumber = (number: $TSFixMe) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

// https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
export const formatMoney = (amountInCents: $TSFixMe, decimalCountParam = 2, decimal = '.', thousands = ',') => {
  try {
    let amount = amountInCents / 100;
    const decimalCount = Number.isNaN(decimalCountParam) ? 2 : Math.abs(decimalCountParam);
    const negativeSign = amount < 0 ? '-' : '';

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number'.
    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)), 10).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
          // @ts-expect-error ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    console.error(e);
  }
};
